import { render, staticRenderFns } from "./Order_identify.vue?vue&type=template&id=cb2597d6&scoped=true&"
import script from "./Order_identify.vue?vue&type=script&lang=js&"
export * from "./Order_identify.vue?vue&type=script&lang=js&"
import style0 from "./Order_identify.vue?vue&type=style&index=0&id=cb2597d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2597d6",
  null
  
)

export default component.exports